import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
const _excluded = ["style", "width", "isOpen", "isLoading", "isAutocomplete", "getMenuProps", "renderWrapper", "renderFooter", "renderLoading", "children"],
  _excluded2 = ["ref", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Overlay from '@adsk/alloy-react-overlay';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import theme, { stylePropType, flattenStyle } from '@adsk/alloy-react-theme';
import NoAutocompleteResults from './NoAutocompleteResults';
import { stripUnknownProps } from '../../helpers/internalHelpers';
const unusedProps = ['selectItem', 'selectedItem', 'selectedItems', 'addSelectedItem', 'removeSelectedItem', 'isGroupHeader', 'highlightedIndex'];
const scrollStyle = {
  position: 'relative',
  overflowY: 'auto'
};
const LoadingSpinner = () => /*#__PURE__*/React.createElement(_StyledDiv, {
  $_css: "".concat(theme.spacing.M, "px 0px")
}, /*#__PURE__*/React.createElement(ProgressRing, null));
const Menu = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style = {},
      width,
      isOpen,
      isLoading = false,
      isAutocomplete = false,
      getMenuProps,
      renderWrapper,
      renderFooter,
      renderLoading = () => /*#__PURE__*/React.createElement(LoadingSpinner, null),
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const showFooter = isOpen && !!renderFooter;
  const wrapperStyle = _objectSpread({}, !isOpen && {
    height: 0
  });
  const parentStyle = [{
    boxShadow: theme.shadows.highElevation,
    backgroundColor: theme.tokens.colors.background.primary.value,
    maxHeight: 300,
    maxWidth: 'calc(100% + 70px)',
    width,
    borderRadius: theme.borderRadius.medium
  }, style];
  const _getMenuProps = getMenuProps(),
    {
      ref: containerRef,
      style: containerStyle
    } = _getMenuProps,
    menuProps = _objectWithoutProperties(_getMenuProps, _excluded2);
  const strippedMenuProps = stripUnknownProps(menuProps, unusedProps);
  const strippedProvidedProps = stripUnknownProps(props, unusedProps);
  const itemsOrMessage = React.Children.toArray(children).length > 0 ? children : /*#__PURE__*/React.createElement(NoAutocompleteResults, null);
  const renderMenu = function () {
    let {
      internalStyle
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/React.createElement(_StyledUl, _extends({
      ref: ref
    }, strippedMenuProps, strippedProvidedProps, {
      $_css2: [theme.typography.labelMedium, {
        listStyleType: 'none',
        userSelect: 'none',
        outline: 'none',
        padding: 0,
        margin: 0
      }, internalStyle]
    }), isOpen && (isLoading ? renderLoading() : isAutocomplete ? itemsOrMessage : children), /*#__PURE__*/React.createElement("div", {
      tabIndex: 0
    }));
  };
  const renderContent = _ref2 => {
    let {
      contentStyle
    } = _ref2;
    return renderWrapper ? renderWrapper({
      style: flattenStyle([contentStyle, wrapperStyle]),
      children: renderMenu()
    }) : renderMenu({
      internalStyle: contentStyle
    });
  };
  return /*#__PURE__*/React.createElement(Overlay.Container, {
    "data-testid": 'Dropdown__menu',
    ref: containerRef,
    style: containerStyle
  }, showFooter ? /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css3: [{
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }, parentStyle]
  }, renderContent({
    contentStyle: scrollStyle
  }), renderFooter()) : renderContent({
    contentStyle: [scrollStyle, parentStyle]
  }));
});
Menu.displayName = 'Menu';
Menu.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The menu width */
  width: PropTypes.number,
  /** The content of the Menu */
  children: PropTypes.any,
  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired,
  /** Toggle loading state */
  isLoading: PropTypes.bool,
  /** Function to get props applied to the <ul> element.  This is returned from the dropdown hook */
  getMenuProps: PropTypes.func.isRequired,
  /**
   * Render a component that will wrap the <ul> element, but still be contained within the overlay.
   * Use this is to enable virtualization
   */
  renderWrapper: PropTypes.func,
  /** Render a component that will appear at the bottom of the menu */
  renderFooter: PropTypes.func,
  /** Render a component that will appear when isLoading is true */
  renderLoading: PropTypes.func
};
export default Menu;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Menu___StyledDiv",
  componentId: "sc-1rpyu8d-0"
})(p => ({
  display: 'flex',
  justifyContent: 'center',
  margin: p.$_css
}));
var _StyledUl = _styled("ul").withConfig({
  displayName: "Menu___StyledUl",
  componentId: "sc-1rpyu8d-1"
})(["", ""], p => p.$_css2);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Menu___StyledDiv2",
  componentId: "sc-1rpyu8d-2"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=Menu.js.map